import styled from 'styled-components';

export const StepsContainer = styled.div`
  width: ${(props) => `${props.width * 200}px`};

  .ant-steps-item-container {
    padding-top: 10px;
  }
  .ant-steps-item-icon {
    display: none;
  }
`;
